import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_gather",
  "use": "icon-control_gather-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_gather\"><g transform=\"translate(2 3)\" stroke=\"currentColor\" fill=\"transparent\"><rect x=\".5\" y=\".5\" width=\"11\" height=\"8\" rx=\"1\" /><path stroke-linecap=\"round\" d=\"M2 10.5h8M3.507 6.45V4.79M5.95 6.45V2.078M8.457 6.45V3.788\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol